import { Switch, Slider, Typography, Space, Divider, Button } from 'antd';
import { PlayCircleOutlined, PauseCircleOutlined, StepForwardOutlined } from '@ant-design/icons';
import useSceneStore from '../../stores/sceneStore';

const { Text } = Typography;

export default function CarouselPanel() {
  const { carousel, setCarousel, markers } = useSceneStore();

  return (
    <div style={{ padding: 12 }}>
      <Text strong style={{ fontSize: 13 }}>数据轮播</Text>
      <Divider style={{ margin: '8px 0' }} />

      <Space orientation="vertical" style={{ width: '100%' }} size="middle">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Text style={{ fontSize: 12, color: '#888' }}>启用轮播</Text>
          <Switch size="small" checked={carousel.enabled}
            onChange={(v) => setCarousel({ enabled: v })} />
        </div>

        {carousel.enabled && markers.length > 0 && (
          <>
            <div>
              <Text style={{ fontSize: 12, color: '#888' }}>自动播放</Text>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                <Switch size="small" checked={carousel.autoPlay}
                  onChange={(v) => setCarousel({ autoPlay: v })} />
                {carousel.autoPlay && (
                  <Text style={{ fontSize: 11, color: '#999' }}>
                    当前: {carousel.currentIndex + 1}/{markers.length}
                  </Text>
                )}
              </div>
            </div>

            <div>
              <Text style={{ fontSize: 11, color: '#999' }}>切换间隔: {carousel.interval}s</Text>
              <Slider min={1} max={10} step={0.5} value={carousel.interval}
                onChange={(v) => setCarousel({ interval: v })} />
            </div>

            <Space>
              <Button size="small" type="primary" icon={<PlayCircleOutlined />}
                disabled={carousel.autoPlay}
                onClick={() => setCarousel({ autoPlay: true })} />
              <Button size="small" icon={<PauseCircleOutlined />}
                disabled={!carousel.autoPlay}
                onClick={() => setCarousel({ autoPlay: false })} />
              <Button size="small" icon={<StepForwardOutlined />}
                onClick={() => setCarousel({
                  currentIndex: (carousel.currentIndex + 1) % markers.length,
                  activeMarkerId: markers[(carousel.currentIndex + 1) % markers.length].id,
                })} />
            </Space>
          </>
        )}

        {carousel.enabled && markers.length === 0 && (
          <Text style={{ fontSize: 11, color: '#666' }}>请先添加标记点</Text>
        )}
      </Space>
    </div>
  );
}
